import { createSlice } from "@reduxjs/toolkit";
import { showNotification } from "./notificationSlice";
import { factory } from "../../api/apiFactory";
const posTypeApi = factory.get("posType");
const initialState = {
  searchBody: {},
  pos_id: null,
  item_id: null,
  posType: {
    loading: false,
    dialog: false,
    form: {
      id: null,
      name: "",
    },
  },
  posTypes: {
    data: [],
    total: 0,
  },
};

export const posTypeSlice = createSlice({
  name: "posType",
  initialState,
  reducers: {
    setDialog: (state, { payload }) => {
      state.posType.dialog = !state.posType.dialog;
    },
    setDataTable: (state, { payload }) => {
      state.posTypes.data = payload.data.data;
      state.posTypes.total = payload.data.total;
    },
    setData: (state, { payload }) => {
      state.posTypes.data = payload.data.data;
    },
    setById: (state, { payload }) => {
      state.posType.form.id = payload.id;
      state.posType.form.name = payload.name;
    },
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
    resetForm: (state, action) => {
      state.posType.form = initialState.posType.form;
    },
    setSearchBody: (state, { payload }) => {
      state.searchBody = payload;
    },
  },
});

export const {
  setLoading,
  setDialog,
  setById,
  setDataTable,
  resetForm,
  setSearchBody,
  setDataList,
} = posTypeSlice.actions;

export default posTypeSlice.reducer;

//axios
const getAll = (params) => async (dispatch) => {
  try {
    dispatch(setLoading("posTypes"));
    const res = await posTypeApi.getAll(params);
    dispatch(setDataTable(res));
    dispatch(setLoading("posTypes"));
  } catch (err) {
    dispatch(setLoading("posTypes"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const deleteById = (id, searchBody) => async (dispatch) => {
  try {
    await posTypeApi.delete(id);
    dispatch(
      showNotification({
        message: "تم الحذف بنجاح",
        type: "success",
      })
    );
    dispatch(getAll(searchBody));
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const getById = (id) => async (dispatch) => {
  try {
    dispatch(setLoading("posType"));
    const res = await posTypeApi.getById(id);
    dispatch(setById(res.data.data[0]));

    dispatch(setLoading("posType"));
  } catch (err) {
    dispatch(setLoading("posType"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const create = (data, searchBody) => async (dispatch) => {
  try {
    dispatch(setLoading("posType"));
    await posTypeApi.create(data);
    dispatch(
      showNotification({
        message: "تمت الاضافة  بنجاح",
        type: "success",
      })
    );
    dispatch(setLoading("posType"));
    dispatch(resetForm());
    dispatch(getAll(searchBody));
  } catch (err) {
    dispatch(setLoading("posType"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const update = (id, data, searchBody) => async (dispatch) => {
  try {
    dispatch(setLoading("posType"));
    await posTypeApi.update(id, data);
    dispatch(
      showNotification({
        message: "تم التعديل بنجاح",
        type: "success",
      })
    );
    dispatch(resetForm());
    dispatch(setLoading("posType"));
    dispatch(setDialog());
    dispatch(getAll(searchBody));
  } catch (err) {
    dispatch(setLoading("posType"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};

export const PosTypeActions = {
  getAll,
  deleteById,
  getById,
  create,
  update,
};
